import React, { useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Form } from "react-bootstrap";
import { MdDelete, MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const TampilAdminWhatsapp = () => {
  const { user, dispatch } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [nama, setNama] = useState("Admin AJS Ecommerce");
  const [nomorWhatsapp, setNomorWhatsapp] = useState("");
  const [aktif, setAktif] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleAuthError = useCallback(
    (err) => {
      if (err.response?.status === 401) {
        dispatch({ type: "LOGOUT" });
      }
    },
    [dispatch],
  );

  const getAdminWhatsapps = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/adminWhatsapps`, {
        _id: user.id,
        token: user.token,
      });
      setData(response.data);
      if (response.data.length > 0 && !selectedId) {
        const firstData = response.data[0];
        setSelectedId(firstData.id);
        setNama(firstData.nama);
        setNomorWhatsapp(firstData.nomorWhatsapp);
        setAktif(Boolean(firstData.aktif));
      }
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil nomor WA Admin.");
    }
    setLoading(false);
  }, [handleAuthError, selectedId, user.id, user.token]);

  useEffect(() => {
    getAdminWhatsapps();
  }, [getAdminWhatsapps]);

  const resetForm = () => {
    setSelectedId("");
    setNama("Admin AJS Ecommerce");
    setNomorWhatsapp("");
    setAktif(true);
  };

  const selectData = (item) => {
    setSelectedId(item.id);
    setNama(item.nama);
    setNomorWhatsapp(item.nomorWhatsapp);
    setAktif(Boolean(item.aktif));
  };

  const saveData = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const payload = {
        nama,
        nomorWhatsapp,
        aktif,
        _id: user.id,
        token: user.token,
      };

      if (selectedId) {
        await axios.post(`${tempUrl}/updateAdminWhatsapp/${selectedId}`, payload);
      } else {
        await axios.post(`${tempUrl}/saveAdminWhatsapp`, payload);
      }

      resetForm();
      await getAdminWhatsapps();
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal menyimpan nomor WA Admin.");
    }
    setLoading(false);
  };

  const deleteData = async (id) => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteAdminWhatsapp/${id}`, {
        _id: user.id,
        token: user.token,
      });
      resetForm();
      await getAdminWhatsapps();
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal menghapus nomor WA Admin.");
    }
    setLoading(false);
  };

  if (loading) return <Loader />;

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Master</div>
          <h1 className="page-title">WA Admin</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveData}>
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Nama Admin</Form.Label>
                <Form.Control value={nama} onChange={(e) => setNama(e.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nomor Whatsapp</Form.Label>
                <Form.Control
                  value={nomorWhatsapp}
                  onChange={(e) => setNomorWhatsapp(e.target.value)}
                  placeholder="Contoh: 6281234567890"
                />
              </Form.Group>
              <Form.Check
                className="mb-3"
                type="checkbox"
                label="Aktif ditampilkan di Ecommerce"
                checked={aktif}
                onChange={() => setAktif(!aktif)}
              />
              <div className="form-actions mt-3">
                <Button className="btn-back" type="button" variant="outline-secondary" onClick={resetForm}>
                  Data Baru
                </Button>
                <Button className="btn-icon" type="submit">
                  <MdSave /> Simpan
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </section>
      <section className="section-panel mt-3">
        <div className="table-responsive">
          <table className="table align-middle">
            <thead>
              <tr>
                <th>Nama</th>
                <th>Nomor Whatsapp</th>
                <th>Aktif</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.id}>
                  <td>{item.nama}</td>
                  <td>{item.nomorWhatsapp}</td>
                  <td>{item.aktif ? "Ya" : "Tidak"}</td>
                  <td>
                    <Button size="sm" className="me-2" onClick={() => selectData(item)}>
                      Pilih
                    </Button>
                    <Button size="sm" variant="outline-danger" onClick={() => deleteData(item.id)}>
                      <MdDelete /> Hapus
                    </Button>
                  </td>
                </tr>
              ))}
              {data.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-muted">
                    Belum ada nomor WA Admin.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default TampilAdminWhatsapp;
